namespace GeniuzPOS.Administration {
    export interface PsSalesVatTypesForm {
        SalesVatType: Serenity.StringEditor;
        SalesVatTypeName: Serenity.StringEditor;
    }

    export class PsSalesVatTypesForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.PsSalesVatTypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsSalesVatTypesForm.init)  {
                PsSalesVatTypesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsSalesVatTypesForm, [
                    'SalesVatType', w0,
                    'SalesVatTypeName', w0
                ]);
            }
        }
    }
}
